import { Icon, IconProps, forwardRef } from "@chakra-ui/react";

export interface BundleIconProps extends IconProps {
    name:
        | "SimcorpFullLogo"
        | "SimcorpTypeLogo"
        | "ArrowForwardIos"
        | "Add"
        | "ArrowBackIos"
        | "ArrowForward"
        | "Close"
        | "Download"
        | "ExpandMore"
        | "Pause"
        | "PlayArrow"
        | "Remove"
        | "Search"
        | "Verified";
    size?: string | (string | number | null)[] | number;
}

const BundleIcon = forwardRef<BundleIconProps, "svg">(({ name, ...props }, ref) => {
    return (
        <Icon {...props} ref={ref}>
            <use xlinkHref={`#sc-${name}`} />
        </Icon>
    );
});
export default BundleIcon;
